import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import "./App.css";

import BrowserRouterPage from "./app/router/RouterPage";
import { withAppWrapper } from "./app/hoc/appWrapper";
import { useMediaQuery } from "@mui/material";

function App() {
  const isMobileScreen = useMediaQuery("(min-width:560px)");
  console.log("testSouceTree");
  return (
    <div className="App">
      {isMobileScreen ? (
        <BrowserRouterPage />
      ) : (
        <iframe
          src="https://navyabaker.svpstaging.com/web/"
          style={{
            width: "100%",
            height: "100vh",
            border: "none",
            paddingBottom: "3rem",
          }}
        />
      )}
    </div>
  );
}

export default withAppWrapper(App);
